import React from "react";
import LazyLoad from "react-lazyload";
import blankJacket from "./../../assets/images/icons/blank_jacket.gif";
import * as Styled from "./Style";

const ConfirmationItem = (props) => {
  return (
    <Styled.ConfirmationItemStyle>
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            {props.itemType && props.itemType == "partial" ? (
              <p className="details-readyQty">
                <span className="ready">
                  {props.readyQty} {props.readyQty == 1 ? "item" : "items"} will
                  be despatched and charged immediately
                </span>
                <br />
                <span className="dued">
                  {props.duedQty} {props.duedQty == 1 ? "item" : "items"} will
                  be despatched and charged when available
                </span>
              </p>
            ) : (
              // <p className="details-duedQty">{props.bookAuthor}</p>
              ""
            )}
          </div>
          <div className="col-8 col-sm-9 col-lg-10">
            <div className="row">
              <div className="col-2 img-col">
                <LazyLoad>
                  <img
                    className="item-img"
                    // src={props.bookImage}
                    src={`${props.bookImage}`}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = blankJacket;
                    }}
                    alt=""
                  />
                </LazyLoad>
              </div>
              <div className="col-12 col-md-7 details">
                <p className="details-title">{props.bookTitle}</p>
                <p className="details-author">{props.bookAuthor}</p>
                <p className="details-isbn">
                  ISBN: {props.bookISBN} <br />
                  {props.bookType}
                </p>
              </div>
              <div className="col-12 col-md-2 price">
                <div className="price-each">
                  {props.bookDiscountedPrice == null ? (
                    props.currency + props.bookPrice
                  ) : (
                    <span>
                      <Styled.DiscountPrice>
                        {props.currency}
                        {""}
                        {props.bookDiscountedPrice}
                      </Styled.DiscountPrice>
                      <br />
                      <Styled.OrigPrice>
                        {props.currency} {props.bookPrice}
                      </Styled.OrigPrice>
                    </span>
                  )}
                </div>
              </div>
              <div className="col-12 col-md-1 qty">{props.counter}</div>
            </div>
          </div>
          <div className="col-4 col-sm-3 col-lg-2">
            <div className="row">
              <div className="col-12 total">
                <div className="price-subtotal">
                  <Styled.ItemSubTotalStyle>
                    {props.currency}
                    {props.bookSubTotal}
                  </Styled.ItemSubTotalStyle>
                </div>
              </div>
              <div className="col-12 qty-mobile">Qty: {props.counter}</div>
            </div>
          </div>
        </div>
      </div>
    </Styled.ConfirmationItemStyle>
  );
};

export default ConfirmationItem;
